"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseStatusStage = exports.CaseStatus = exports.CaseImpactStatus = exports.CaseResolutionStatus = void 0;
const __1 = require("..");
var CaseResolutionStatus;
(function (CaseResolutionStatus) {
    CaseResolutionStatus["INDETERMINATE"] = "Indeterminate";
    CaseResolutionStatus["FALSE_POSITIVE"] = "FalsePositive";
    CaseResolutionStatus["TRUE_POSITIVE"] = "TruePositive";
    CaseResolutionStatus["OTHER"] = "Other";
    CaseResolutionStatus["DUPLICATED"] = "Duplicated";
})(CaseResolutionStatus = exports.CaseResolutionStatus || (exports.CaseResolutionStatus = {}));
var CaseImpactStatus;
(function (CaseImpactStatus) {
    CaseImpactStatus["NO_IMPACT"] = "NoImpact";
    CaseImpactStatus["WITH_IMPACT"] = "WithImpact";
    CaseImpactStatus["NOT_APPLICABLE"] = "NotApplicable";
})(CaseImpactStatus = exports.CaseImpactStatus || (exports.CaseImpactStatus = {}));
var CaseStatus;
(function (CaseStatus) {
    CaseStatus["OPEN"] = "Open";
    CaseStatus["RESOLVED"] = "Resolved";
    CaseStatus["DELETED"] = "Deleted";
})(CaseStatus = exports.CaseStatus || (exports.CaseStatus = {}));
var CaseStatusStage;
(function (CaseStatusStage) {
    CaseStatusStage["NEW"] = "New";
    CaseStatusStage["IN_PROGRESS"] = "InProgress";
    CaseStatusStage["CLOSED"] = "Closed";
})(CaseStatusStage = exports.CaseStatusStage || (exports.CaseStatusStage = {}));
